define([
	"dojo/_base/declare",
	"csi",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,csi,Switchboard) {

	return declare(Switchboard, {
		disableButtonAction: true,
		resDefault: "SelectAll",
		switchboardPath: "Child:TestRunSections",

		validatePlugin: function(/*Context*/ctx) {
			// summary: do not show in aggregate or print view
			return !ctx.bPopup && !ctx.bPrint && !ctx.view.getToolbarContainerView();
		},

		_onChangeSelect: function(/*String*/value) {
			// summary: if empty value, then convert to TRS
			if (value == csi.EMPTY_URL) {
				value = this.actionToolbar.view.urlTestRunRevision;
			}

			this.inherited(arguments, [value]);
		}
	});
});